export const FORM_TIMEOUT_MS = 10000;
export const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;
export const BUSCA_CEP_URL =
  'https://buscacepinter.correios.com.br/app/endereco/index.php';

export const UI_BUTTON_SPACING = 40;
export const CHAVE_API_TRANSPARENCIA = '14ec36816423d110db926332eecccfe8';

export const DEFAULT_TIMEZONE = -3;
